import { render, staticRenderFns } from "./UsersByGroup.vue?vue&type=template&id=594218b0&scoped=true"
import script from "./UsersByGroup.vue?vue&type=script&lang=js"
export * from "./UsersByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594218b0",
  null
  
)

export default component.exports